import { useMemo } from 'react';

/**
 * Merges an array of refs into a single memoized callback ref or `null`.
 */
export const useMergeRefs = refs => {
  return useMemo(() => {
    if (refs.every(ref => ref == null)) {
      return null;
    }
    return value => {
      refs.forEach(ref => {
        if (typeof ref === 'function') {
          ref(value);
        } else if (ref != null) {
          /* eslint-disable-next-line no-param-reassign */
          ref.current = value;
        }
      });
    };
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, refs);
};